import React, { Component } from "react";
import "./DynamicAsset.scss";

class DynamicAsset extends Component {
  render() {
    return (
      <div className="dynamic-content-asset">
        <div
          className="dynamic-content-asset-thumbnail"
          id={this.props.CTAid}
        ></div>
        <div className="dynamic-content-asset-content">
          <div className="dynamic-content-asset-label">{this.props.assetTitle}</div>
          <div className="dynamic-content-asset-text">
            {this.props.description}
          </div>
          <a
            className="btn dynamic-content-asset-btn"
            href={this.props.ctaURL}
            target="_blank"
            rel="noreferrer"
            tabindex={this.props.tabby}
          >
            {this.props.ctaText}
          </a>
        </div>
      </div>
    );
  }
}

export default DynamicAsset;
